// Centralized in-app URL builders.
//
// IMPORTANT: these build *router URL paths*, NOT Firestore document paths.
// Firestore paths use the `spaces/{spaceId}/...` form and must never go through here.
//
// The tenant prefix lives in ONE place (`APP_PREFIX`) so the whole app can be
// moved under a different base (e.g. `/app`) by changing a single constant.

// URL prefix for all authenticated app routes. Change in ONE place to relocate
// the entire app (e.g. '' for root, '/app' for a path-prefixed app).
export const APP_PREFIX = '/app'

type Segment = string | number | undefined | null

const joinSegments = (segments: Segment[]): string =>
  segments
    .filter((s): s is string | number => s !== undefined && s !== null && s !== '')
    .map(String)
    .join('/')

// Build a tenant (space) route path, e.g. spacePath(id, 'songs', songId) -> `/{id}/songs/{songId}`
export const spacePath = (spaceId: string | string[], ...segments: Segment[]): string => {
  const id = Array.isArray(spaceId) ? spaceId.join('/') : String(spaceId)
  const suffix = joinSegments(segments)
  const tail = suffix ? `/${id}/${suffix}` : `/${id}`
  return `${APP_PREFIX}${tail}`
}

// Build a non-tenant app route path, e.g. appPath('spaces') -> `/spaces`, appPath('account') -> `/account`
export const appPath = (...segments: Segment[]): string => {
  const tail = joinSegments(segments)
  return `${APP_PREFIX}/${tail}`
}
